import { MakeLogicType, actions, kea, path, reducers } from 'kea'
import { windowValues } from 'kea-window-values'

// Generated by kea-typegen. Update if you're an agent, ignore if you're human.
export interface navigationLogicValues {
    fullscreen: boolean
    isConfigureHomeModalOpen: boolean
    mobileLayout: boolean
}

// Generated by kea-typegen. Update if you're an agent, ignore if you're human.
export interface navigationLogicActions {
    hideConfigureHomeModal: () => {
        value: true
    }
    showConfigureHomeModal: () => {
        value: true
    }
}

export type navigationLogicType = MakeLogicType<navigationLogicValues, navigationLogicActions>

export const navigationLogic = kea<navigationLogicType>([
    path(['layout', 'navigation', 'navigationLogic']),
    actions({
        showConfigureHomeModal: true,
        hideConfigureHomeModal: true,
    }),
    windowValues(() => ({
        fullscreen: (window: Window) => !!window.document.fullscreenElement,
        mobileLayout: (window: Window) => window.innerWidth < 992, // Sync width threshold with Sass variable $lg!
    })),
    reducers({
        isConfigureHomeModalOpen: [
            false,
            {
                showConfigureHomeModal: () => true,
                hideConfigureHomeModal: () => false,
            },
        ],
    }),
])
